// /src/features/onboarding/onboarding.config.ts
import { FeatureStepModule } from './steps/FeatureStep';
import { IndustryStepModule } from './steps/IndustryStep';
import { RecordingOptionsStepModule } from './steps/RecordingOptionsStep';
import { RoleStepModule } from './steps/RoleStep';
import { Step, StepSlug } from './types/types';

export { StepSlug }; // re-export enum for the rest of the app

export const steps: Step[] = [
  IndustryStepModule,
  RoleStepModule,
  FeatureStepModule,
  RecordingOptionsStepModule
];
